import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { GroupsTreeNode, ITreeNode } from "src/app/core/datasets/tree.interface";
import { AdminService } from "../admin/admin.service";

@Component({
  selector: 'restoreid-group-tree-node',
  templateUrl: './group-tree-node.component.html',
  styleUrls: ['./group-tree-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupTreeNodeComponent {
  @Input() node!: ITreeNode;

  constructor(private _adminService: AdminService) {}

  public get childNodes() {
    return (this.node as GroupsTreeNode).children || [];
  }

  selectGroup() {
    this._adminService.changeSelectedGroup.emit((this.node as GroupsTreeNode).group_id);
  }
}
